<template>
    <div class="grcform">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"
            v-on:popupopened="SetPopupRef('Dialog')"
            v-on:popupclosed="SetPopupRef('')"
        ></GrcDialog>
    <GrcDialogPayment ref="DialogPayment"
        v-on:popupopened="SetPopupRef('DialogPayment')"
        v-on:popupclosed="SetPopupRef('')"
    ></GrcDialogPayment>


        <div class="grc_fullwidth_lane">
            <div class="grc_maincont_lane" style="padding-left: 4px;">
              <div class="grc_sectionheader" style="margin-top:10px; margin-bottom:10px;">
                  <span class="line color1">
                    <span class="title_general" style="padding-left:10px !important;">
                      {{title}}
                      </span>
                  </span>
              </div>
            </div>
        </div>

        

        <div class="grc_fullwidth_lane">
        <div class="grc_maincont_lane" style="padding:10px;">

            <div class="main_col_cont" v-show="innerformid==2">
                <div class="main_col">
                    <div class="innerform" style="text-align:justify;" v-html="sikeres_text">
                    </div>
                </div>
            </div>

            <div class="main_col_cont" v-show="innerformid==1">
                <div class="main_col">
                    <div class="innerform">
                        <GrcText ref="txtNev" grc_labeltext="Családi és utóneve:" grc_placeholder="..."
                        grc_labelmode="" grc_labelwidth="200px" 
                        v-on:grc-keydown-enter="SetControlToFocus('txtSzuletesiIdo');"
                        style="margin-bottom:20px;"
                        />

                        <GrcDate ref="txtSzuletesiIdo" v-model="SzuletesiIdo" grc_dateformat="ymd" grc_sep="." 
                        grc_labeltext="Születési idő:" grc_labelmode="" grc_labelwidth="200px" grc_readonly="false"
                        v-on:grc-keydown-enter="SetControlToFocus('txtEmailIf');"
                        v-on:dropdownopened="SetPopupRef('txtSzuletesiIdo')"
                        v-on:dropdownclosed="SetPopupRef('')"
                        style="margin-bottom:20px;"
                        />

                        <GrcNum ref="txtTagkod" v-model="tagkod" v-show="ShowTagkodAdoazon"
                        grc_labeltext="<span style='color:red;'>Tagkód:</span>" grc_labelmode="above" grc_labelwidth="200px"
                        grc_currency="" grc_decimalplaces="0" grc_readonly="false"
                        v-on:grc-keydown-enter="SetControlToFocus('txtAdoazon');"
                        style="margin-bottom:20px;"
                        />

                        <GrcAdoazon ref="txtAdoazon" v-model="adoazon" v-show="ShowTagkodAdoazon"
                        grc_labeltext="<span style='color:red;'>Adóazonosító jel:</span>" grc_labelmode="" grc_labelwidth="200px"
                        v-on:grc-keydown-enter="SetControlToFocus('txtEmailCim');"
                        style="margin-bottom:20px;"
                        />


                        <GrcText ref="txtEmailCim" grc_labeltext="Értesítési e-mail cím:" grc_placeholder="..."
                        grc_labelmode="" grc_labelwidth="200px" 
                        v-on:grc-keydown-enter="SetControlToFocus('txtTagdijOsszeg');"
                        style="margin-bottom:20px;"
                        />

                        <GrcNum ref="txtTagdijOsszeg" v-model="TagdijOsszeg" 
                        grc_labeltext="Tagdíj:" grc_labelmode="above" grc_labelwidth="200px"
                        grc_currency="Ft" grc_decimalplaces="0" grc_readonly="false"
                        v-on:grc-keydown-enter="SetControlToFocus('txtMukodesiOsszeg');"
                        style="margin-bottom:20px;"
                        />

                        <GrcNum ref="txtMukodesiOsszeg" v-model="MukodesiOsszeg" 
                        grc_labeltext="Működési támogatás:" grc_labelmode="above" grc_labelwidth="200px"
                        grc_currency="Ft" grc_decimalplaces="0" grc_readonly="false"
                        v-on:grc-keydown-enter="SetControlToFocus('');"
                        />


                        <table style="width:100%; margin-top:20px; margin-bottom:20px;" cellspacing="0" cellpadding="0">
                        <tr>
                            <td style="width:45px; padding-top:7px;" valign="top"><GrcCheckboxMobile ref="chkFelhFelt" /></td>
                            <td valign="top" style="text-align:left; font-family:'PremiumDefault'; font-size:14px; line-height:18px; color:#222;">
                                Elfogadom a <span class="bankkartya_felt_popup_link" @click="ShowBankkartyaFeltPopup()">bankkártyás fizetés feltételeit</span> 
                            </td>
                        </tr>
                        </table>     

                        <div class="simple_infotext" v-html="simple_infotext" style="margin-bottom:20px;"></div>       


                        <div class="btn_cont">

                            <GrcButton grc_text="TOVÁBB A BANKKÁRTYÁS FIZETÉSI OLDALRA" @grc-click="btnStartPreparePayment_click" grc_readonly="false" 
                            grc_color="blue" grc_shadow="false" grc_radius="2px" grc_width="338px"
                            grc_buttonpos="right"
                            grc_textalign="center"
                            grc_righticon="<i class='fas fa-chevron-right'></i>"
                            style="display:inline-block;" />                    

                        </div>

                    </div>



                </div>
                <div class="main_col">
                    <div class="infotext" v-html="infotext" />
                </div>
            </div>
            





        </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCombo from '../GrcComponents/GrcCombo.vue'
import GrcText from '../GrcComponents/GrcText.vue'
import GrcDate from '../GrcComponents/GrcDate.vue'
import GrcNum from '../GrcComponents/GrcNum.vue'
import GrcAdoazon from '../GrcComponents/GrcAdoazon.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'
import GrcDialogPayment from '../GrcComponents/GrcDialogPayment.vue'

export default {
  name: 'frmBefizetes',
  components: {
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcCombo,
      GrcText,
      GrcDate,
      GrcNum,
      GrcAdoazon,
      GrcCheckboxMobile,
      GrcDialogPayment
  },
  props: {
  },
  data () {
      return {
            WSPREFIX: "frmBefizetes",
            gPopupControlName:"",

            title:"",
            infotext:"",
            SzuletesiIdo:"",
            TagdijOsszeg:0,
            MukodesiOsszeg:0,
            tagkod:0,
            adoazon:"",
            feltetel:"",
            ShowTagkodAdoazon:false,
            btnPreparePayment_text:"TOVÁBB A BANKKÁRTYÁS FIZETÉSI OLDALRA",
            BefizResultInfoText:"",
            IsTokenReg:"",
            TokenRegResult_text:"",
            sikeres_text:"",
            innerformid:1,

            simple_infotext:"",
            
      }
  },
  model: {
  },  
  methods:{

    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },

    scrollToTop() { window.scrollTo(0,0); },

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmBefizetes", pCompName);
    },

    SetControlToFocus(pNextComp)
    {
        if (pNextComp == "") { return; }

        if (pNextComp == "txtEmailIf")
        {
            if (this.ShowTagkodAdoazon) { pNextComp = "txtTagkod"; }
            else { pNextComp = "txtEmailCim"; }
        }


        this.$refs[pNextComp].SetFocus();
    },

    async ShowBankkartyaFeltPopup()
    {
        let pText = grcmain_GetTextBookItem("tech", "bankkartya_felt_popuptext");

        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = 400;
        p.width = 500;
        p.padding_top = -1; //20;
        if (grccomp_getScreenSize().width < 400) { p.width = 340; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               

    },


    SetLang()
    {
        this.title = this.GetTextBookItem("title");
        this.infotext = this.GetTextBookItem("info_text");
        this.feltetel = this.GetTextBookItem("feltetel");
        this.TokenRegResult_text = this.GetTextBookItem("TokenRegResult_text");

        this.simple_infotext = grcmain_GetTextBookItem("tech", "bankkartya_felt_simpletext");

        this.Init();
    },

      HideErrors()
      {
        //this.$refs.ErrorBox.HideError();
        this.$refs.txtNev.HideError();
        this.$refs.txtSzuletesiIdo.HideError();
        this.$refs.txtTagkod.HideError();
        this.$refs.txtAdoazon.HideError();
        this.$refs.txtEmailCim.HideError();
        this.$refs.txtTagdijOsszeg.HideError();
        this.$refs.txtMukodesiOsszeg.HideError();
      },

    async btnStartPreparePayment_click()
    {
        this.HideErrors();

        if (this.$refs.chkFelhFelt.GetValue() == 0)
        {
            await this.ShowInfoDialog("A felhasználási feltételek elfogadása kötelező!", 200);
            return;
        }

        var ErrorCompName = "";

        if (this.$refs.txtNev.GetText() == "")
        {
            if (ErrorCompName == "") { ErrorCompName = "txtNev"; }
            this.$refs.txtNev.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.txtSzuletesiIdo.GetText() == '')
        {
          if (ErrorCompName == "") { ErrorCompName = "txtSzuletesiIdo"; }
          this.$refs.txtSzuletesiIdo.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.ShowTagkodAdoazon)
        {
            if ((this.$refs.txtTagkod.GetValue() == 0) && (this.$refs.txtAdoazon.GetText() == ""))
            {
                if (ErrorCompName == "") { ErrorCompName = "txtTagkod"; }
                this.$refs.txtTagkod.ShowError("A tagkód és/vagy adóazonosító jel megadása kötelező!");
                this.$refs.txtAdoazon.ShowError("A tagkód és/vagy adóazonosító jel megadása kötelező!");
            }
        }


        if (grcmain_IsValidEmailAddress(this.$refs.txtEmailCim.GetText()) == false)
        {
          if (ErrorCompName == "") { ErrorCompName = "txtEmailCim"; }
          if (this.$refs.txtEmailCim.GetText() == "")
          {
            this.$refs.txtEmailCim.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
          }
          else
          {
            this.$refs.txtEmailCim.ShowError(grcmain_GetTextBookItem("tech", "email_format_error"));
          }
        }

        /*
        if (this.$refs.txtTagdijOsszeg.GetValue() == 0)
        {
          if (ErrorCompName == "") { ErrorCompName = "txtTagdijOsszeg"; }
          this.$refs.txtTagdijOsszeg.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }
        */

        if (ErrorCompName != "")
        {
          this.SetControlToFocus(ErrorCompName);
          return;
        }

        this.PreparePayment_Dialog();
    },


    async PreparePayment_Dialog()
    {

        var pEmailCim = this.$refs.txtEmailCim.GetText();

        this.scrollToTop();


        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
            iTagdijOsszeg: this.$refs.txtTagdijOsszeg.GetValue(),
            iMukodesiOsszeg: this.$refs.txtMukodesiOsszeg.GetValue(),
            sNev: this.$refs.txtNev.GetText(),
            sSzuletesiIdo: this.$refs.txtSzuletesiIdo.GetText(),
            iTagkod: this.$refs.txtTagkod.GetValue(),
            sAdoazon: this.$refs.txtAdoazon.GetText(),
            sEmailCim: this.$refs.txtEmailCim.GetText(),
            sOrderNumPrefix: "EB",
        };

        //console.log(QP);

        var Q;
        await this.$refs.GRCDB.GetData("frmBefizetes_PreparePayment", QP).then(res => { Q = res; });

        //console.log(Q);

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            this.ShowInfoDialog(Q.APPERR[0].ERR, 200);
            return;
        }

        if (Q.hasOwnProperty('HIBA'))
        {
            if (Q.HIBA[0].intResult != 1)
            {
                this.$refs.GRCDB.HideLoading();
                this.ShowInfoDialog(Q.HIBA[0].strResult, 200);
                this.ShowTagkodAdoazon = true;
                return;
            }
        }


        //console.log(Q.PAYMENT);

        this.$refs.GRCDB.HideLoading();
        
        if (Q.PAYMENT[0].intResult != 1)
        {
            alert(Q.PAYMENT[0].strResult);
            return;
        }

        let OrderNumber = Q.PAYMENT[0].ORDER_REF;

        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults("", "");             
        p.height = 1000;
        p.width = 1000;
        p.padding_top = -1;
        p.title = "<i class='fal fa-credit-card' style='margin-right:6px;'></i>" + "Bankkártyás fizetés";
        await this.$refs.DialogPayment.ShowDialog(p, Q).then(res => 
        { 
            DialogResult = res; 
        });       

        // if (DialogResult == 3) // backref ágra ment, ellenőrizni az eredményt

        this.$refs.GRCDB.ShowLoading(false);

        var QP2 = {
            sRefNum: OrderNumber,
        };
        
        var Q2;
        await this.$refs.GRCDB.GetData("frmBefizetes_CheckResult", QP2).then(res => { Q2 = res; });


        if (Q2.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            this.$emit("handlecommerror", Q2.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        if (Q2.TXDATA[0].intResult == 1)
        {
            /*
            let s = this.GetTextBookItem("sikeres_popuptext");
            await this.ShowResult(s, 250);
            this.$emit("navigate", "default");
            */

            this.sikeres_text = Q2.TXDATA[0].strResult;
            this.innerformid = 2;

        }


    },



    async PreparePayment()
    {
        this.scrollToTop();


        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
            sNev: this.$refs.txtNev.GetText(),
            sSzuletesiIdo: this.$refs.txtSzuletesiIdo.GetText(),
            iTagkod: this.$refs.txtTagkod.GetValue(),
            sAdoazon: this.$refs.txtAdoazon.GetText(),
            sEmailCim: this.$refs.txtEmailCim.GetText(),
            sOsszeg: this.$refs.txtOsszeg.GetValue(),
        };
        var Q;
        await this.$refs.GRCDB.GetData("frmBefizetes_PreparePayment", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {

            this.$refs.GRCDB.HideLoading();
            if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
            {
                this.$emit("handlecommerror", Q.APPERR[0].ERR);
            }
            else
            {            
                this.ShowInfoDialog(Q.APPERR[0].ERR, "200");
            }
            return;
        }


        //console.log(Q.PAYMENT);

        this.$refs.GRCDB.HideLoading();
        
        if (Q.HIBA[0].intResult != 1)
        {
            this.ShowInfoDialog(Q.HIBA[0].strResult, 200);
            this.ShowTagkodAdoazon = true;
            return;
        }

        let OrderNumber = Q.PAYMENT[0].ORDER_REF;

        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults("", "");             
        p.height = 1000;
        p.width = 1000;
        p.padding_top = -1;
        p.title = "<i class='fal fa-credit-card' style='margin-right:6px;'></i>" + "Bankkártyás fizetés";
        await this.$refs.DialogPayment.ShowDialog(p, Q).then(res => 
        { 
            DialogResult = res; 
        });       

        // if (DialogResult == 3) // backref ágra ment, ellenőrizni az eredményt

        this.$refs.GRCDB.ShowLoading(false);

        var QP2 = {
            sRefNum: OrderNumber,
            sSessionID: "[APPSESSIONID]"
        };
        
        var Q2;
        await this.$refs.GRCDB.GetData("frmBefizetes_CheckResult", QP2).then(res => { Q2 = res; });

        //console.log(Q2);

        if (Q2.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            this.ShowInfoDialog(Q2.APPERR[0].ERR, 250);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        if (Q2.TXDATA[0].intResult == 1)
        {
            this.sikeres_text = Q2.TXDATA[0].SikeresText;
            this.innerformid = 2;
        }



    },


    async Init()
    {
        this.InfoText = "";

        var lnkazon = "";
        if ((GRCAPP_GetParameters.ALIAS == "befizetes") && (GRCAPP_GetParameters.LNKAZON != "") && (GRCAPP_GetParameters.LNKAZON != undefined))
        {
            lnkazon = GRCAPP_GetParameters.LNKAZON;
            GRCAPP_GetParameters.LNKAZON = "";
        }


        this.$refs.GRCDB.ShowLoading(false);
        
        var QP = {
        };
        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX+"_Init", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
            {
                this.$emit("handlecommerror", Q.APPERR[0].ERR);
            }
            else
            {            
                this.ShowInfoDialog(Q.APPERR[0].ERR, "200");
            }
            return;
        }

        if (lnkazon != "")
        {
            QP = {
                sAzonosito: lnkazon
            };
            var Q;
            await this.$refs.GRCDB.GetData("frmBefizetes_GetLinkData", QP).then(res => { Q = res; });

            if (Q.APPERR[0].ERR != "")
            {
                if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
                {
                    this.$emit("handlecommerror", Q.APPERR[0].ERR);
                }
                return;
            }


            if (Q.APPERR[0].ERR == "")
            {
                if (Q.RESULT.length > 0)
                {
                    this.$refs.txtNev.SetText(Q.RESULT[0].Nev);
                    this.$refs.txtSzuletesiIdo.SetText(Q.RESULT[0].SzuletesiIdo);
                    this.$refs.txtTagkod.SetValue(Q.RESULT[0].Tagkod);
                    this.$refs.txtEmailCim.SetText(Q.RESULT[0].EmailCim);
                    this.$refs.txtTagdijOsszeg.SetValue(Q.RESULT[0].TagdijOsszeg);
                    this.$refs.txtMukodesiOsszeg.SetValue(Q.RESULT[0].MukodesiOsszeg);
                }
            }
        }


        
        this.$refs.GRCDB.HideLoading();


        
    },


    async ShowInfoDialog(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 340; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },



  },

  created()
  {

  },

  mounted()
  {
    gForm = this;
    gPopupControlName = "";

    if (gAppInitDone)
    {
      this.SetLang();
    }
  }

}


</script>


<style scoped>

.maintitle
{
    width: 100%;
    box-sizing: border-box;
    color:#fff;
    font-family: "PremiumDefault";
    font-size:22px;
    line-height: 22px;
    font-weight:normal;
    text-align: left;
    padding: 10px;
}

.main_col_cont
{
    width:100%;
    box-sizing: border-box;
}

.main_col
{
    width:50%;
    box-sizing: border-box;
    display:inline-block;
    vertical-align: top;
}

.innerform
{
    width:100%;
    box-sizing: border-box;
}

.infotext
{
    width: 100%;
    box-sizing: border-box;
    color: #323232;
    font-family: "PremiumDefault";
    font-size:16px;
    line-height: 22px;
    font-weight:normal;
    text-align: justify;
    padding: 0px 10px 0px 20px;
}

div >>> .info_title
{
    width: 100%;
    box-sizing: border-box;
    color: var(--premblue);
    font-family: "PremiumDefault";
    font-size:18px;
    line-height: 22px;
    font-weight:normal;
    text-align: left;
    padding: 10px 0px;
    font-weight: 500;
}


.btn_cont
{
  width:100%;
  box-sizing: border-box;
  padding:4px 0px;
  border-top:solid 0px #ccc;
  margin-top: 0px;
  text-align: center;
}

.btn
{
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  font-family: 'PremiumDefault';
  font-weight: normal;
  text-align: center;  
  background-color:var(--premblue);
  color:#fff;
  padding:8px 8px;
  cursor:pointer;
  border-radius: 2px;
  margin: 2px;
  min-width: 120px;
}

.btn_gray2
{
  background-color: #ccc;
  color:#222;
}

.btn:hover
{
  background-color: var(--premgreen);
  color:#fff;
}

.btn_icon
{
    margin-right:4px;
}

.btn_text
{
    display:inline;
}

.btn_gray
{
  background-color: #ccc;
  color:#fff;
  cursor: default;
  opacity: 0;
}

.btn_gray:hover
{
  background-color: #ccc;
  color:#fff;
  cursor: default;
  opacity: 0;
}

.bankkartya_felt_popup_link
{
    background-color: var(--premsarga);
    color: #fff;
    font-size: 14px;
    line-height: 14px;
    display: inline-block;
    padding: 8px;
    text-decoration: none;
    border-radius: 2px;
    padding-top: 9px;
    margin:1px;
    cursor: pointer;
}

.bankkartya_felt_popup_link:hover
{
    opacity: 0.9;
}

.simple_infotext
{
    width:100%;
    box-sizing: border-box;
    text-align: justify;
    font-size: 15px;
    line-height: 20px;
    color: #222;    
    font-weight: normal;
}

>>> .lnk_inline
{
    background-color: var(--premsarga);
    color: #fff;
    font-size: 14px;
    line-height: 14px;
    display: inline-block;
    padding: 8px;
    text-decoration: none;
    border-radius: 2px;
    padding-top: 9px;
    margin:1px;
}

>>> .lnk_inline:hover
{
    opacity:0.9;
}

>>> .lnk_inline:visited
{
    color:#fff;
}



@media (max-width:900px)
{
    .infotext
    {
        font-size:14px;
        line-height: 18px;
    }

}

@media (max-width:700px)
{
    .main_col
    {
        width:100%;
    }

    .infotext
    {
        font-size:14px;
        line-height: 18px;
        padding: 30px 0px 20px 0px;
    }
}


</style>